// extracted by mini-css-extract-plugin
export var htmlPreview = "_r2-2";
export var modal = "_r2-0";
export var sidebar = "_r2-1";